import { useMemo } from 'react'
import { useAuthStore } from '../store/authStore'
import { isUserFromMedendoTeam } from '../medendoTeam'

export const useIsUserFromMedendoTeam = (): boolean => {
    const payload = useAuthStore((state) => state.payload)
    return useMemo(() => {
        return isUserFromMedendoTeam(payload?.email)
    }, [payload?.email])
}
